<div (click)="onOptionClick('View')"
  class="grid grid-cols-[75px_2fr_1.5fr_1fr_1.5fr_1.3fr_90px_70px] gap-2 px-5 py-3.5 border-b border-slate-100 dark:border-slate-700/50 hover:bg-blue-50/40 hover:shadow-[inset_3px_0_0_#0D76BA] transition-all duration-150 items-center relative cursor-pointer group">

  <!-- Date -->
  <div class="text-left">
    <p class="text-[11px] font-bold text-slate-700 dark:text-slate-300 uppercase">{{ institution()?.createdAt | date: "dd MMM" }}</p>
    <p class="text-[10px] text-slate-400 font-medium">{{ institution()?.createdAt | date: "yyyy" }}</p>
  </div>

  <!-- Name with avatar -->
  <div class="flex items-center justify-start gap-2.5 min-w-0">
    <div class="w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0 text-white text-[10px] font-bold bg-primary-800">
      {{ institution()?.name?.charAt(0)?.toUpperCase() || '?' }}
    </div>
    <div class="min-w-0">
      <p class="text-xs font-bold text-slate-900 dark:text-white group-hover:text-primary-800 dark:text-primary-400 transition-colors truncate">{{ institution()?.name }}</p>
      <p class="text-[10px] text-slate-400 font-medium truncate">{{ institution()?.code || '—' }}</p>
    </div>
  </div>

  <!-- Address -->
  <div class="min-w-0 text-left">
    <p class="text-xs text-slate-500 dark:text-slate-400 truncate">{{ institution()?.address || '—' }}</p>
  </div>

  <!-- Contact -->
  <div class="min-w-0 text-left">
    <p class="text-xs font-semibold text-slate-700 dark:text-slate-300 truncate">{{ institution()?.contact || '—' }}</p>
  </div>

  <!-- Email -->
  <div class="min-w-0 text-left">
    <p class="text-xs text-slate-500 dark:text-slate-400 truncate">{{ institution()?.email || '—' }}</p>
  </div>

  <!-- Assigned To -->
  <div class="min-w-0 text-left">
    <p class="text-xs text-slate-500 dark:text-slate-400 truncate">
      @if (institution()?.assignedTo; as assignedTo) {
      {{ assignedTo.firstName }} {{ assignedTo.lastName }}
      } @else {
      —
      }
    </p>
  </div>

  <!-- Status -->
  <div class="flex justify-start">
    @if (institution()?.isActive === true) {
    <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold bg-emerald-50 dark:bg-emerald-950/40 text-emerald-600 dark:text-emerald-400 border border-emerald-100 dark:border-emerald-900 uppercase tracking-wider leading-none">
      <span class="w-1 h-1 rounded-full bg-emerald-500 inline-block"></span>Active
    </span>
    } @else {
    <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold bg-slate-50 dark:bg-slate-800/60 text-slate-400 border border-slate-200 dark:border-slate-700 uppercase tracking-wider leading-none">
      <span class="w-1 h-1 rounded-full bg-slate-300 inline-block"></span>Inactive
    </span>
    }
  </div>

  <!-- Actions -->
  <div class="flex justify-center relative">
    @if (showProfileIcon()) {
    <button (click)="onActionClick(); $event.stopPropagation()"
      class="p-1.5 rounded-lg transition-all text-slate-400 hover:text-slate-700 dark:text-slate-300 hover:bg-white dark:bg-slate-800 hover:shadow-sm">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <circle cx="12" cy="5" r="1.5"/><circle cx="12" cy="12" r="1.5"/><circle cx="12" cy="19" r="1.5"/>
      </svg>
    </button>
    } @else {
    <button (click)="onOptionClick('View'); $event.stopPropagation()"
      class="px-2 py-1 text-xs font-semibold text-slate-600 dark:text-slate-400 border border-slate-200 dark:border-slate-700 rounded hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60 hover:border-slate-300 dark:border-slate-600 transition-colors">
      View
    </button>
    }

    @if (isActionClick) {
    <div class="absolute top-full right-0 mt-1 w-44 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl shadow-xl overflow-hidden z-50">
      @for (option of dropdownOptions; track $index) {
      <button (click)="onOptionClick(option.title); $event.stopPropagation()"
        class="w-full flex items-center gap-3 px-4 py-2.5 text-xs border-b border-slate-50 last:border-b-0 transition-colors"
        [class]="option.title === 'Delete' ? 'text-rose-600 hover:bg-rose-50' : option.title === 'Activate' ? 'text-emerald-600 dark:text-emerald-400 hover:bg-emerald-50 dark:hover:bg-emerald-950/40' : option.title === 'Deactivate' ? 'text-amber-600 hover:bg-amber-50' : 'text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60'">
        @if (option.title.includes('Delete')) {
        <svg class="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>
        } @else if (option.title.includes('View')) {
        <svg class="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/></svg>
        } @else if (option.title.includes('Edit')) {
        <svg class="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/></svg>
        } @else if (option.title.includes('Deactivate')) {
        <svg class="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"/></svg>
        } @else if (option.title.includes('Activate')) {
        <svg class="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
        } @else if (option.title.includes('Add')) {
        <svg class="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"/></svg>
        } @else {
        <svg class="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
        }
        <span class="font-semibold">{{ option.title }}</span>
      </button>
      }
    </div>
    }
  </div>

  @if (isActionClick) {
  <div class="fixed inset-0 z-40" (click)="onActionClick(); $event.stopPropagation()"></div>
  }
</div>

@if (showDeleteDialog) {
<app-confirmation-dialog [title]="'Delete Institution'" [message]="'Are you sure you want to delete this institution?'"
  [itemName]="institution()?.name || ''" [confirmText]="'Delete'" [cancelText]="'Cancel'" [type]="'danger'"
  (onConfirm)="confirmDelete()" (onCancel)="cancelDelete()"></app-confirmation-dialog>
}

@if (showStatusDialog) {
<app-confirmation-dialog [title]="institution()?.isActive ? 'Deactivate Institution' : 'Activate Institution'"
  [message]="institution()?.isActive ? 'Are you sure you want to deactivate this institution?' : 'Are you sure you want to activate this institution?'"
  [itemName]="institution()?.name || ''" [confirmText]="institution()?.isActive ? 'Deactivate' : 'Activate'"
  [cancelText]="'Cancel'" [type]="'warning'" (onConfirm)="confirmStatusToggle()"
  (onCancel)="cancelStatusToggle()"></app-confirmation-dialog>
}
